// (ملف جديد: src/WebhookSetupPage.js)
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, auth } from './firebase';
import { doc, updateDoc } from 'firebase/firestore';
import { signOut } from 'firebase/auth';

// ده كومبوننت جديد بيستقبل 3 حاجات: اليوزر، وبيانات العميل، والدالة اللي بتحدث البيانات
function WebhookSetupPage({ user, clientData, setClientData }) {
  const [secret, setSecret] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('خطأ في تسجيل الخروج:', error);
    }
  };

  // 1. بنحدد الرابط حسب نوع المنصة (shopify أو easyorder)
  const platform = clientData.platform || 'shopify'; // default to shopify
  
  // 🔥 تحديد الـ Webhook الصحيح حسب المنصة
  const webhookConfig = platform === 'easyorder' ? {
    id: '90b3766d-c689-41a4-b69c-b784f5715456',
    path: 'easy_order-hook-alsayes3'
  } : {
    id: '213c991d-9702-406b-9908-a621481ca80d',
    path: 'shopify-hook-alsayes3'
  };
  
  const fullWebhookURL = `https://n8n2.dafaiagency.shop/webhook/${webhookConfig.id}/${webhookConfig.path}/${clientData.webhook_path_id}`;

  // 2. عناوين وإرشادات مختلفة حسب المنصة
  const platformInstructions = platform === 'shopify' ? {
    title: '🎉 خطوة واحدة أخيرة يا',
    steps: [
      'اذهب إلى لوحة تحكم شوبيفاي (Shopify Admin).',
      'اذهب إلى Settings > Notifications.',
      'انزل لآخر الصفحة حتى تجد قسم "Webhooks".',
      'اضغط "Create webhook".',
      'في خانة "Event"، اختر "Order creation".',
      'في خانة "Format"، اختر "JSON".',
      'في خانة "URL"، انسخ الرابط التالي:',
    ],
    secretLabel: 'Shopify Shared Secret',
    secretField: 'shopify_shared_secret',
    secretInstructions: 'بعد الضغط على "Save" في شوبيفاي، هيظهرلك "Signing secret". انسخه والصقه في الخانة اللي تحت، واضغط "حفظ وتفعيل".',
  } : {
    title: '🎉 خطوة واحدة أخيرة يا',
    steps: [
      'اذهب إلى لوحة تحكم EasyOrder.',
      'اذهب إلى Settings > Integrations.',
      'اضغط "Add Webhook".',
      'في خانة "Event Type"، اختر "Order Created".',
      'في خانة "Webhook URL"، انسخ الرابط التالي:',
    ],
    secretLabel: 'EasyOrder Secret Key',
    secretField: 'easyorder_shared_secret',
    secretInstructions: 'بعد حفظ الويب هوك في EasyOrder، هيظهرلك "Secret Key". انسخه والصقه في الخانة اللي تحت، واضغط "حفظ وتفعيل".',
  };

  const handleSaveSecret = async (e) => {
    e.preventDefault();
    if (!secret) {
      setError('لا يمكن ترك الحقل فارغاً');
      return;
    }
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // 2. بنحدد مكان الدوكيومنت بتاع العميل (اللي هو اسم البراند)
      const clientDocRef = doc(db, 'clients_api', clientData.brand_name);
      
      // 3. بنحدث الحقل بتاع السيكرت (يختلف حسب المنصة)
      await updateDoc(clientDocRef, {
        [platformInstructions.secretField]: secret
      });

      // 4. (مهم) بنحدث الـ state في الداش بورد عشان الصفحة تتغير
      setClientData(prevData => ({
        ...prevData,
        [platformInstructions.secretField]: secret
      }));

      setSuccess('تم الحفظ بنجاح! جاري تحويلك للداشبورد...');
      
      // تحديث الصفحة بعد ثانية واحدة
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (err) {
      console.error(err);
      setError('حدث خطأ أثناء الحفظ. حاول مرة أخرى.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={setupStyles.container}>
      <div style={setupStyles.card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <button onClick={handleLogout} style={setupStyles.logoutButton}>
            تسجيل خروج
          </button>
          <h2 style={{color: '#00b4d8', margin: 0}}>
            {platformInstructions.title} {clientData.brand_name}!
          </h2>
        </div>
        <p style={{color: '#f8f8f2', fontSize: '16px', marginBottom: '20px'}}>
          تم إنشاء حسابك بنجاح. لتفعيل الخدمة، يرجى إتباع الآتي:
        </p>
        
        <ol style={setupStyles.list}>
          {platformInstructions.steps.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </ol>

        <input 
          type="text" 
          readOnly 
          value={fullWebhookURL} 
          style={setupStyles.input} 
        />
        <button onClick={() => navigator.clipboard.writeText(fullWebhookURL)} style={setupStyles.copyButton}>
          نسخ الرابط
        </button>

        <div style={setupStyles.secretSection}>
          <p style={setupStyles.secretTitle}>📋 الخطوة الأخيرة:</p>
          <p style={setupStyles.secretInstructions}>
            {platformInstructions.secretInstructions}
          </p>
        </div>

        <form onSubmit={handleSaveSecret}>
          <input 
            type="text" 
            placeholder={platformInstructions.secretLabel}
            value={secret}
            onChange={(e) => setSecret(e.target.value)}
            style={setupStyles.input}
          />
          <button type="submit" disabled={loading} style={setupStyles.saveButton}>
            {loading ? 'جاري الحفظ...' : 'حفظ وتفعيل'}
          </button>
        </form>
        {error && <p style={{ color: '#ff5555', marginTop: '10px' }}>{error}</p>}
        {success && <p style={{ color: '#50fa7b', marginTop: '10px' }}>{success}</p>}
      </div>
    </div>
  );
}

// ستايلات لصفحة الإعداد
const setupStyles = {
  container: {
    padding: '20px',
    background: '#121212',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    backgroundColor: '#1e1e2f',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0, 180, 216, 0.15)',
    border: '1px solid #44475a',
    padding: '35px',
    maxWidth: '750px',
    width: '100%',
    textAlign: 'right',
  },
  list: {
    textAlign: 'right',
    paddingRight: '20px',
    lineHeight: '1.8',
    color: '#f8f8f2',
    fontSize: '15px',
  },
  code: {
    backgroundColor: '#282a36',
    padding: '2px 6px',
    borderRadius: '4px',
    fontFamily: 'monospace',
    color: '#50fa7b',
  },
  input: {
    width: '100%',
    padding: '12px',
    margin: '10px 0',
    boxSizing: 'border-box',
    border: '1px solid #44475a',
    borderRadius: '4px',
    fontSize: '14px',
    textAlign: 'left',
    background: '#282a36',
    color: '#f8f8f2',
  },
  copyButton: {
    width: '100%',
    padding: '10px',
    backgroundColor: '#6272a4',
    color: '#f8f8f2',
    border: '1px solid #44475a',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: 'bold',
    borderRadius: '4px',
  },
  saveButton: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#50fa7b',
    color: '#282a36',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  secretSection: {
    marginTop: '30px',
    marginBottom: '20px',
    padding: '20px',
    backgroundColor: '#282a36',
    borderRight: '4px solid #00b4d8',
    borderRadius: '6px',
  },
  secretTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#00b4d8',
    marginBottom: '10px',
  },
  secretInstructions: {
    fontSize: '15px',
    lineHeight: '1.8',
    color: '#f8f8f2',
    margin: 0,
  },
  logoutButton: {
    padding: '10px 20px',
    backgroundColor: '#ff5555',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
  }
};

export default WebhookSetupPage;